import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>O Que Ofereço</h5>
      <h2>Serviços</h2>

      <div className="container services__container">
      <article className='service'>
        <div className="service__head">
          <h3>Desenvolvimento Fullstack</h3>
        </div>
        <ul className="service__list">
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Desenvolvimento de Aplicações Web</p>
          </li>
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Desenvolvimento de Aplicações Móveis</p>
          </li>
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Integração de APIs</p>
          </li>
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Desenvolvimento Backend</p>
          </li>
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Otimização de Performance</p>
          </li>
        </ul>
        </article>
        {/* END OF FULLSTACK DEV*/}

        <article className='service'>
        <div className="service__head">
          <h3>Suporte Técnico e Informática</h3>
        </div>
        <ul className="service__list">
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Configuração de Redes (CCNA) - básico</p>
          </li>
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Suporte Técnico</p>
          </li>
          <li>
            <BiCheck className='service__list-icon'/>
            <p>Instalação de Software</p>
          </li>

        </ul>
        </article>
        {/* END OF IT*/}
        </div>
    </section>
  )
}

export default Services